const change = {
  positive(params) {
    return parseFloat(params.value) > 0 || params.value === 'up';
  },
  neutral(params) {
    return parseFloat(params.value) === 0 || params.value === 'right';
  },
  negative(params) {
    return parseFloat(params.value) < 0 || params.value === 'down';
  }
};

export {
  // Rule Packs
  change
};
